import { BriefcaseIcon } from './BriefcaseIcon';

/**
 * author: Google
 * id 15A9F4A5-3EB6-443C-8283-547A077CB0C4
 * name briefcase
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase.svg
 * tags
 */
export const WorkIcon = BriefcaseIcon;
export default WorkIcon